import {useCallback, useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {MultiInputFormik, TimePickerFormik} from 'components';
import {UserContext} from 'context';
import {TRANSLATION_KEYS} from 'locale';
import {WorkingHoursInterval, WorkingHours as WorkingHoursType} from 'types';
import {workingHoursUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.WORKING_HOURS;

type Props = {
    name: string;
    itemsPath: string;
    values: WorkingHoursType;
}

export const MultiInputInterval: React.FC<Props> = ({name, values, itemsPath}) => {
    const {t} = useTranslation();
    const {settings: {common: {timeZone, timeFormat}}} = useContext(UserContext);

    const isIntervalValid = useCallback((interval: WorkingHoursInterval) => workingHoursUtils.validateInterval(interval, t).isValid, [t]);

    return (
        <MultiInputFormik
            name={name}
            itemsPath={itemsPath}
            values={values}
            isValid={isIntervalValid}
            defaultValue={{from: null, to: null}}
        >
            {({index, item, path, renderActions}) => (
                <div key={index} className='tw-flex tw-items-baseline'>
                    <div className='tw-flex tw-items-baseline tw-mb-4'>
                        <TimePickerFormik
                            hasEmptyOption
                            name={`${path}.from`}
                            timeZone={timeZone}
                            timeFormat={timeFormat}
                            placeholder={t(T_KEYS.LABELS.FROM)}
                            className='tw-w-28 tw-mr-2'
                        />
                        <TimePickerFormik
                            hasEmptyOption
                            name={`${path}.to`}
                            timeZone={timeZone}
                            timeFormat={timeFormat}
                            placeholder={t(T_KEYS.LABELS.TO)}
                            className='tw-w-28'
                        />
                    </div>
                    <div className='tw-w-10 tw-ml-3 tw-self-center tw-mt-3'>
                        {renderActions({index, item})}
                    </div>
                </div>
            )}
        </MultiInputFormik>
    );
};

